<template>
  <!--设备综合统计-->
   <dv-border-box-13>
    <div class="item" :style="{ height: col + 'vh' }">
      <div class="font-weight font-s">{{title}}</div>
      <div class="sycm">
        <el-row :style="{'line-height':(col/8)+'vh'}">
          <el-col :span="6">
             <span class="font-weight font-l block">{{ bean.count }}台</span>
            <span class="font">设备总数</span>
          </el-col>
          <el-col :span="6">
             <span class="font-weight font-l block">{{ bean.count - bean.errorCount }}个</span>
            <span class="font">正常</span>
          </el-col>
          <el-col :span="6">
            <span class="font-weight font-l block">{{ bean.errorCount }}个</span>
            <span class="font">异常</span>
          </el-col>
          <el-col :span="6">
            <span class="font-weight font-l block">{{ bean.power }}个</span>
            <span class="font">低电量</span>
          </el-col>
          <el-col :span="24">
            <div
              style="border-bottom: 1px solid rgba(255, 255, 255, 0.1);margin-top:10px"
            ></div>
          </el-col>
          <el-col :span="6">
            <span class="font-weight font-l block">{{ bean.confirm }}个</span>
            <span class="font">待确认</span>
          </el-col>
          <el-col :span="6">
            <span class="font-weight font-l block">{{ bean.pending }}个</span>
            <span class="font">待响应</span>
          </el-col>
          <el-col :span="6">
            <span class="font-weight font-l block">{{ bean.process }}个</span>
            <span class="font">待处理</span>
          </el-col>
          <el-col :span="6">
            <span class="font-weight font-l block">{{ bean.evaluate }}个</span>
            <span class="font">待评价</span>
          </el-col>
        </el-row>
      </div>
    </div>
  </dv-border-box-13>

</template>

<script>
export default {
  name: "andon-top",
  props: {
    col: {
      type: Number,
      default: function () {
        return 28;
      },
    },
    deviceBean: {
      type: Object,
      default: function () {
        return {};
      },
    },
    headTitle:{
      type: String,
      default: function () {
        return "设备总览";
      },
    },
  },
  data() {
    return {
      title:this.headTitle,
      bean: this.deviceBean,
    };
  },
  watch: {
    deviceBean: {
      handler: function (val, oldVal) {
        this.bean = val;
      },
      deep: true,
    }
  },
};
</script>


<style scoped>
.item {
  padding: 0.33rem 0.4rem 0.2rem;
}
.sycm{
  padding:10px;
}
.value{
  font-size:3vh;
  font-weight: bold;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/andon/component/device-total.vue